import type { Store } from 'redux'
import type { RootState } from './types'

let appStore: Store<RootState> | null = null

export const registerStore = (store: Store<RootState>): void => {
  appStore = store
}

export const getStore = (): Store<RootState> => {
  if (!appStore) {
    throw new Error('store accessed before initialization')
  }
  return appStore
}
